import React, { Fragment }  from 'react'
import PropTypes from 'prop-types'
import { translate } from 'parking-react-common'

import { compact, get } from 'lodash'

import Panel from '../components/Panel'
import InfoTable from '../components/InfoTable'
import SessionsList from '../components/SessionsList'
import { Column } from '../components/Grid'


const DetailedSessionsList = ({ parkingLot, t, ...otherProps }) => {
    const recentSesssionsNumber = get(parkingLot, 'recent_sessions')

    const sessionDetails = compact([
        {
            title : `${t('Last 24H sessions')}:`,
            value : recentSesssionsNumber
        }
    ])

    return (
        <Fragment>
            <Panel title={ t('Session Details') } hasTable withDivider>
                <Column span={ 6 }>
                    <InfoTable data={ sessionDetails } />
                </Column>
            </Panel>
            <SessionsList
                { ...otherProps }
            />
        </Fragment>
    )
}

DetailedSessionsList.propTypes = {
    title        : PropTypes.node,
    subtitle     : PropTypes.node,
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string,
    parkingLot   : PropTypes.object
}

export default translate()(DetailedSessionsList)
